import { motion } from "framer-motion";

export const SectionHeading = ({ eyebrow, title, sub, align = "left", className = "", eyebrowColor = "text-dream-violet" }) => (
  <motion.div
    initial={{ opacity: 0, y: 24 }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-60px" }}
    transition={{ duration: 0.6 }}
    className={`${align === "center" ? "text-center mx-auto" : ""} max-w-3xl ${className}`}
  >
    <p className={`font-mono text-xs tracking-[0.3em] uppercase mb-4 ${eyebrowColor}`}>{eyebrow}</p>
    <h2 className="font-heading text-3xl sm:text-4xl lg:text-5xl font-bold text-white tracking-tight leading-[1.05]">{title}</h2>
    {sub && <p className="text-white/55 text-base md:text-lg mt-4 leading-relaxed">{sub}</p>}
  </motion.div>
);

export const PayLaterPill = ({ className = "", testId }) => (
  <span
    className={`inline-flex items-center gap-2 px-4 py-2 rounded-full bg-white/[0.06] border border-white/15 backdrop-blur-xl text-sm ${className}`}
    data-testid={testId}
  >
    <span className="w-2 h-2 rounded-full bg-[#b2fce4] animate-pulse" />
    <span className="text-white font-semibold">Create Today, Pay Later</span>
    <span className="text-white/50 hidden sm:inline">· Afterpay &amp; Zip on every service</span>
  </span>
);
